import { TextWrapper, Wrapper, TextWrapperSpan, StyledImage, FlexRow } from "../../../constants/common/StyledGlobalConstants";
import { Checkbox, CheckboxGroup } from "@vds/checkboxes";
import styled from "styled-components";
import { Colors } from "../../../constants/Colors";
import PopOutIcon from "../../../assets/icons/Blue_Vector.svg";
import SkeletonLoader from "../common/SkeletonLoader";
import { useSelector, useDispatch } from "react-redux";
import { fetchMaterialList } from "../../../store/actions/schedulingportal/technicianAppointment";
import TryAgain from "./TryAgain";
import { FormContainer } from "../../myContract/ContactMe.styles";
import { getPendoId } from "../../../util/cfstPendoUtils";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";
import PropTypes from "prop-types";

const { TABLET } = DEVICE_BREAKPOINTS;

export const StarSpan = styled.span`
  color: ${(props) => (props.disabled ? `${Colors.disabledText}` : `${Colors.activeDefault}`)};
  padding: 0 0 0 4px;
  font-size: 14px;
`;

const CheckboxContainer = styled(Wrapper)`
  display: flex;
  flex-direction: row;
  color: blue;
  & [class^="CheckboxGroupWrapper-VDS"] > div {
    padding-bottom: 1rem;
  }
  & [class^="CheckboxGroupWrapper-VDS"] > div:nth-child(3) {
    padding-bottom: 0rem !important;
  }
  & [class^="CheckboxGroupWrapper-VDS"]:last-child > div:last-child {
    padding-bottom: 0rem !important;
  }
  @media (max-width: 767px) {
    flex-direction: column;
    & [class^="CheckboxGroupWrapper-VDS"] > div:nth-child(3) {
      padding-bottom: 1rem !important;
    }
  }
  & [class^="CheckboxGroupWrapper-VDS"] {
    flex: 1;
    color: red;
    & div {
      & div {
        & label {
          font-family: "neue-haas-grotesk-text";
          font-size: 0.875rem;
          font-weight: 400;
          line-height: 1.25rem;
          & div {
            & span {
              height: 1rem;
              width: 1rem;
            }
          }
        }
        & label > div {
          margin-right: 0.5rem;
        }
      }
    }
  }
`;

const CameraCheckbox = styled(Checkbox)`
  margin-top: 1rem;
  font-family: "neue-haas-grotesk-text";
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  color: #000;
  & div {
    margin-right: 0.5rem;
    & span {
      width: 1rem !important;
      height: 1rem !important;
      & div {
        margin-right: 0rem;
      }
    }
  }
`;

const ACCESSORIES_LIST = ["No accessories connected", "Driver ID", "Panic/privacy button", "Logbook", "Power Take Off (PTO)"];

function CamerasAndOtherAccessories({ selectedAccessories, setSelectedAccessories, setHighlightAccessories, highlightAccessories, selectedVinOrPA }) {
  const {
    accountDetails,
    materialList: { data: materialListData, error: materialListApiError },
    accessoriesLoader,
    // isDeviceNeverReported,
  } = useSelector((state) => state.TECHNICIANAPPOINTMENT);
  const { windowSize } = useSelector((state) => state.ACCOUNT);
  const dispatch = useDispatch();

  const handleMaterialListAPI = () => {
    //fetch materials list data when selected vin is not powered asset and materials list data is empty from the store
    if (!materialListData?.length && selectedVinOrPA?.isVin) {
      if (accountDetails?.data?.salesOrg) {
        let payload = {
          salesOrg: accountDetails.data.salesOrg,
          // isGovernment: accountDetails?.data?.vzcSegement?.toLowerCase().includes("government") ? "YES" : "NO",
          isGovernment: "NO",
        };
        dispatch(fetchMaterialList(payload));
      }
    }
  };

  const accessoriesHandler = (e, value) => {
    let accessoryList = selectedAccessories ? [...selectedAccessories] : [];
    const accessoryIndex = accessoryList.findIndex((accessory) => accessory === value.value);
    if (value.value === "No accessories connected") {
      accessoryList = accessoryIndex !== -1 ? [] : [value.value]; //clear and disable other accessories when "No accessories connected" is selected
    } else if (accessoryIndex !== -1) {
      accessoryList.splice(accessoryIndex, 1); //remove the value from the list when checkbox is unselected
    } else {
      accessoryList.push(value.value); //add the value to the list when checkbox is selected
    }
    setSelectedAccessories(accessoryList.length ? accessoryList : null);
    setHighlightAccessories(() => (!accessoryList.length));
  };

  const checkboxData = (accessories) => {
    return accessories.map((accessory) => ({
      onChange: accessoriesHandler,
      children: accessory,
      value: accessory,
      selected: !!selectedAccessories?.find((selectedAccessory) => selectedAccessory === accessory),
      disabled:
        !!selectedAccessories &&
        ((selectedAccessories[0] === "No accessories connected" && accessory !== "No accessories connected") ||
          (selectedAccessories[0] !== "No accessories connected" && accessory === "No accessories connected")),
    }));
  };

  return (
    <Wrapper display="flex" flexDirection="column" alignItems="flex-start" marginTop="2rem">
      {accessoriesLoader ? (
        <>
          {/* // Skeleton loader for the accessories section */}
          <SkeletonLoader width="41.76%" height="1.5rem" />
          <SkeletonLoader height="3rem" />
          <FormContainer desktop={windowSize.width >= TABLET} style={{ width: "100%" }}>
            <SkeletonLoader width={windowSize.width < TABLET ? "100%" : "50%"} height={windowSize.width < TABLET ? "16rem" : "8rem"} />
            {windowSize.width >= TABLET && <SkeletonLoader width="50%" height="8rem" />}
          </FormContainer>
          <SkeletonLoader width="41.76%" height="1.5rem" marginTop="1.5rem" />
        </>
      ) : (
        <>
          <TextWrapper fontSize="1.25rem" fontWeight="700" lineHeight="1.5rem">
            Accessories
          </TextWrapper>
          <TextWrapper fontSize="0.875rem" fontWeight="400" marginTop="1rem !important" lineHeight="1.25rem">
            To help the technician plan the time and equipment required, select all accessories connected to the current vehicle, excluding the
            tracker.
          </TextWrapper>
          {materialListApiError !== null && !materialListApiError ? (
            <>
              {selectedVinOrPA.cameras.length > 0 && (
                <CameraCheckbox name="default" width="auto" selected disabled value="Camera">
                  Camera (Detected by system)
                </CameraCheckbox>
              )}
              <TextWrapper
                fontSize="0.875rem"
                fontWeight="700"
                marginTop={selectedVinOrPA.cameras.length > 0 ? "1.5rem !important" : "1rem !important"}
                lineHeight="1.25rem"
                color={highlightAccessories ? "#C44904" : "#000000"}
                role={highlightAccessories && "alert"}
                aria-label="No accessories selected, please select any accessories connected to the current vehicle, excluding the tracker."
              >
                Select all that apply:<StarSpan>*</StarSpan>
              </TextWrapper>
              <CheckboxContainer marginTop="1rem" width="100%">
                <CheckboxGroup
                  childWidth="100%"
                  data={checkboxData(ACCESSORIES_LIST.slice(0, 3))}
                  id={getPendoId("accessories-checkbox-group-one")}
                />
                <CheckboxGroup childWidth="100%" data={checkboxData(ACCESSORIES_LIST.slice(3))} id={getPendoId("accessories-checkbox-group-two")} />
              </CheckboxContainer>
            </>
          ) : (
            <TryAgain padding="4.188rem 0rem 3.188rem 0rem" handleClick={handleMaterialListAPI} />
          )}
          <FlexRow marginTop="1.5rem" alignItems="center">
            <TextWrapperSpan
              isLink
              aria-label="Accessory guide"
              tabIndex="0"
              color="#006FC1"
              fontSize="0.875rem"
              fontWeight="400"
              lineHeight="0.875rem"
              textDecorationLine="underline"
              id={getPendoId("camera-accessory-guide-link")}
              onClick={() => window.open("https://reveal-help.verizonconnect.com/hc/articles/37721657388819")}
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") && window.open("https://reveal-help.verizonconnect.com/hc/articles/37721657388819")
              }
            >
              Accessory guide
            </TextWrapperSpan>
            <a href="https://reveal-help.verizonconnect.com/hc/articles/37721657388819" target="_blank" tabIndex="-1" aria-hidden="true">
              <TextWrapperSpan verticalAlign="middle" tabIndex="-1" aria-hidden="true">
                <StyledImage
                  width="0.75rem"
                  height="0.75rem"
                  marginLeft="0.5rem"
                  src={PopOutIcon}
                  alt="link"
                  id={getPendoId("camera-accessory-guide-icon")}
                />
              </TextWrapperSpan>
            </a>
          </FlexRow>
        </>
      )}
    </Wrapper>
  );
}
CamerasAndOtherAccessories.propTypes = {
  selectedAccessories: PropTypes.array,
  setSelectedAccessories: PropTypes.func.isRequired,
  setHighlightAccessories: PropTypes.func.isRequired,
  highlightAccessories: PropTypes.bool.isRequired,
  selectedVinOrPA: PropTypes.shape({
    isVin: PropTypes.bool,
    cameras: PropTypes.array
  }).isRequired
};

export default CamerasAndOtherAccessories;